import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';

import firebase from 'firebase/app';
import firebaseConfig from './firebaseConfig';

import { Howl, Howler } from 'howler';
import Notifications from 'vue-notification';
import velocity from 'velocity-animate';

import Keyboard from './components/Keyboard.vue';
import PostCard from './components/PostCard.vue';
import Confirm from './components/Confirm.vue';
import Share from './components/Share.vue';

import './assets/scss/fonts.scss';
import './mixins/utility';
import './registerServiceWorker';

Vue.config.productionTip = false;

Vue.use(Howl);
Vue.use(Howler);
Vue.use(Notifications, { velocity });

Vue.component('Keyboard', Keyboard);
Vue.component('PostCard', PostCard);
Vue.component('Confirm', Confirm);
Vue.component('Share', Share);

firebase.initializeApp(firebaseConfig);

const createApp = () => {
  firebase.auth().onAuthStateChanged(userData => {
    console.log('createApp', !userData);
    if (userData) {
      store.dispatch('setUserData', userData);
      if (router.app._route.name === 'login') {
        router.push(router.app._route.query.redirect || { name: 'home' });
      }
    } else {
      store.dispatch('setUserData', null);
      if (router.app._route.name === 'login' && router.app._route.query.redirect) {
        router.push({ name: 'login' });
      }
    }
  });
  new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
  }).$mount('#app');
};

createApp();
